export const toLocaleDateString = (date) => {
    let d = new Date(date)
    return d.toLocaleDateString()
}

export const toLocaleTimeString = (date) => {
    let d = new Date(date)
    return d.toLocaleTimeString()
}

export const toLocaleString = (date) => {
    let d = new Date(date)
    return d.toLocaleString()
}



// WEBPACK FOOTER //
// ./src/utils/date.js